module.exports = __webpack_public_path__ + "assets_1775109859079/img/guide_ios.431fc979.png";